import { Controller } from "stimulus";

export default class extends Controller
{
    initialize()
    {
        this.clickEH = this.click.bind(this);
    }

    connect()
    {
        this.element.addEventListener("click", this.clickEH)
    }

    click(e)
    {
        if(this.element.classList.contains("closed"))
        {
            this.element.classList.remove("closed");
            this.element.nextElementSibling.classList.remove("hidden");
        }
        else
        {
            this.element.classList.add("closed");
            this.element.nextElementSibling.classList.add("hidden");
        }
    }

    disconnect()
    {
        this.element.removeEventListener("click", this.clickEH);
    }
    
}